const INNER_SEPARATOR_CLASSES = 'border border-moss-grey-150 rounded-[4px] ml-[-1px] mt-[-1px]'
const TOP_SEPARATOR_CLASSES = 'ml-[-1px] rounded-b-[4px] border-x border-b border-moss-grey-150'
const BOTTOM_SEPARATOR_CLASSES = 'ml-[-1px] mt-[-1px] rounded-t-[4px] border-x border-t border-moss-grey-150'

const LEFT_SEPARATOR_CLASSES = 'mt-[-1px] rounded-r-[4px] border-y border-r border-moss-grey-150'
const LEFT_TOP_SEPARATOR_CLASSES = 'rounded-br-[4px] border-b border-r border-moss-grey-150'
const LEFT_BOTTOM_SEPARATOR_CLASSES = 'mt-[-1px] rounded-tr-[4px] border-r border-t border-moss-grey-150'

const RIGHT_SEPARATOR_CLASSES = 'ml-[-1px] mt-[-1px] rounded-l-[4px] border-y border-l border-moss-grey-150'
const RIGHT_TOP_SEPARATOR_CLASSES = 'ml-[-1px] rounded-bl-[4px] border-b border-l border-moss-grey-150'
const RIGHT_BOTTOM_SEPARATOR_CLASSES = 'ml-[-1px] mt-[-1px] rounded-tl-[4px] border-l border-t border-moss-grey-150'

export const CenterSeparators = () => (
  <>
    {/* Top */}
    <div className={`col-span-1 col-start-2 row-start-1 ${TOP_SEPARATOR_CLASSES}`} />
    <div className={`col-span-1 col-start-5 row-start-1 ${TOP_SEPARATOR_CLASSES} max-md:hidden`} />
    <div className={`col-span-1 col-start-6 row-start-1 ${TOP_SEPARATOR_CLASSES} max-md:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-1 ${TOP_SEPARATOR_CLASSES} max-md:hidden`} />
    <div className={`col-span-1 col-start-4 row-start-1 ${TOP_SEPARATOR_CLASSES} max-md:hidden`} />
    <div className={`col-span-1 col-start-7 row-start-1 ${TOP_SEPARATOR_CLASSES} max-xl:hidden`} />
    <div className={`col-span-1 col-start-8 row-start-1 ${TOP_SEPARATOR_CLASSES} max-xl:hidden`} />
    {/* Middle */}
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-2 row-start-3`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-2 row-start-5 lg:max-xl:col-start-3 lg:max-xl:row-start-2`} />
    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-2 max-md:hidden md:row-start-6 lg:max-xl:col-start-3 lg:max-xl:row-start-3`}
    />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-2 row-start-7 lg:max-xl:col-start-3 lg:max-xl:row-start-4`} />
    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-2 row-start-9 md:row-start-2 lg:max-xl:col-start-4 lg:max-xl:row-start-3`}
    />
    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-2 row-start-11 md:row-start-4 lg:max-xl:col-start-5 lg:max-xl:row-start-2`}
    />

    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-3 row-start-3 max-md:hidden lg:max-xl:col-start-5 lg:max-xl:row-start-3`}
    />
    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-3 row-start-5 max-md:hidden lg:max-xl:col-start-5 lg:max-xl:row-start-4`}
    />

    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-4 row-start-2 max-md:hidden lg:max-xl:col-start-6 lg:max-xl:row-start-3`}
    />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-4 row-start-3 max-md:hidden lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-4 row-start-4 max-md:hidden lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-4 row-start-5 max-md:hidden lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-4 row-start-6 max-md:hidden lg:max-xl:hidden`} />

    <div className={`${INNER_SEPARATOR_CLASSES} col-start-5 row-start-3 max-md:hidden lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-5 row-start-5 max-md:hidden lg:max-xl:hidden`} />

    <div className={`${INNER_SEPARATOR_CLASSES} col-start-7 row-start-3 max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-8 row-start-2 max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-8 row-start-3 max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-8 row-start-4 max-xl:hidden`} />

    <div className={`${INNER_SEPARATOR_CLASSES} col-start-6 row-start-3 max-md:hidden lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-6 row-start-5 max-md:hidden lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-6 max-md:hidden md:row-start-6 lg:max-xl:hidden`} />
    <div className={`${INNER_SEPARATOR_CLASSES} col-start-6 row-start-7 max-md:hidden lg:max-xl:hidden`} />
    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-6 row-start-9 max-md:hidden md:row-start-2 lg:max-xl:hidden`}
    />
    <div
      className={`${INNER_SEPARATOR_CLASSES} col-start-6 row-start-11 max-md:hidden md:row-start-4 lg:max-xl:hidden`}
    />
    {/* Bottom */}
    <div
      className={`col-span-1 col-start-2 row-start-[13] ${BOTTOM_SEPARATOR_CLASSES} md:col-start-3 md:row-start-7 lg:max-xl:col-start-2 lg:max-xl:row-start-5`}
    />
    <div
      className={`col-span-1 col-start-2 row-start-[13] ${BOTTOM_SEPARATOR_CLASSES} max-md:hidden md:col-start-4 md:row-start-7 lg:max-xl:col-start-3 lg:max-xl:row-start-5`}
    />
    <div
      className={`col-span-1 col-start-2 row-start-[13] ${BOTTOM_SEPARATOR_CLASSES} max-md:hidden md:col-start-5 md:row-start-7 lg:max-xl:col-start-4 lg:max-xl:row-start-5`}
    />
    <div
      className={`col-span-1 col-start-2 row-start-[13] ${BOTTOM_SEPARATOR_CLASSES} max-lg:hidden max-md:hidden md:col-start-5 md:row-start-7 lg:max-xl:col-start-5 lg:max-xl:row-start-5`}
    />
    <div
      className={`col-span-1 col-start-2 row-start-[13] ${BOTTOM_SEPARATOR_CLASSES} max-lg:hidden max-md:hidden md:col-start-5 md:row-start-7 lg:max-xl:col-start-6 lg:max-xl:row-start-5`}
    />
    <div className={`col-span-1 col-start-7 row-start-5 ${BOTTOM_SEPARATOR_CLASSES} max-xl:hidden`} />
    <div className={`col-span-1 col-start-8 row-start-5 ${BOTTOM_SEPARATOR_CLASSES} max-xl:hidden`} />
  </>
)

export const SideSeparators = () => (
  <>
    {/* Left */}
    <div className={`col-span-1 col-start-1 row-start-1 ${LEFT_TOP_SEPARATOR_CLASSES}`} />
    <div className={`col-span-1 col-start-1 row-start-2 ${LEFT_SEPARATOR_CLASSES}`} />
    <div className={`col-span-1 col-start-1 row-start-3 ${LEFT_SEPARATOR_CLASSES}`} />
    <div className={`col-span-1 col-start-1 row-start-4 ${LEFT_SEPARATOR_CLASSES}`} />
    <div className={`col-span-1 col-start-1 row-start-5 ${LEFT_SEPARATOR_CLASSES}`} />
    <div className={`col-span-1 col-start-1 row-start-6 ${LEFT_SEPARATOR_CLASSES} xl:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-7 ${LEFT_SEPARATOR_CLASSES} xl:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-8 ${LEFT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-9 ${LEFT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-10 ${LEFT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-11 ${LEFT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-12 ${LEFT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-1 row-start-13 ${LEFT_BOTTOM_SEPARATOR_CLASSES} md:hidden`} />

    {/* Right */}
    <div
      className={`col-span-1 col-start-3 row-start-1 ${RIGHT_TOP_SEPARATOR_CLASSES} md:col-start-7 xl:col-start-9`}
    />
    <div className={`col-span-1 col-start-3 row-start-2 ${RIGHT_SEPARATOR_CLASSES} md:col-start-7 xl:col-start-9`} />
    <div className={`col-span-1 col-start-3 row-start-3 ${RIGHT_SEPARATOR_CLASSES} md:col-start-7 xl:col-start-9`} />
    <div className={`col-span-1 col-start-3 row-start-4 ${RIGHT_SEPARATOR_CLASSES} md:col-start-7 xl:col-start-9`} />
    <div className={`col-span-1 col-start-3 row-start-5 ${RIGHT_SEPARATOR_CLASSES} md:col-start-7 xl:col-start-9`} />
    <div className={`col-span-1 col-start-3 row-start-6 ${RIGHT_SEPARATOR_CLASSES} md:col-start-7 xl:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-7 ${RIGHT_SEPARATOR_CLASSES} md:col-start-7 xl:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-8 ${RIGHT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-9 ${RIGHT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-10 ${RIGHT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-11 ${RIGHT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-12 ${RIGHT_SEPARATOR_CLASSES} md:hidden`} />
    <div className={`col-span-1 col-start-3 row-start-13 ${RIGHT_BOTTOM_SEPARATOR_CLASSES} md:hidden`} />
  </>
)

type GradientProps = {
  color: string
  gradientStart: number
  height: number
  location: 'top' | 'bottom'
}

export const Gradient = ({color, gradientStart, height, location}: GradientProps) => (
  <div
    className={`absolute mt-[-1px] w-full ${location === 'top' ? 'top-0' : 'bottom-0'}`}
    style={{
      backgroundImage: `linear-gradient(to ${
        location === 'top' ? 'bottom' : 'top'
      }, rgb(${color}), rgb(${color}) ${gradientStart}%, transparent)`,
      height: `${height}px`,
    }}
  />
)
